/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiRerunPeriodicScenarioRequest
 */
export interface InternalApiRerunPeriodicScenarioRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalApiRerunPeriodicScenarioRequest
     */
    scenarioHandle: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiRerunPeriodicScenarioRequest
     */
    timestamp: Date;
}

/**
 * Check if a given object implements the InternalApiRerunPeriodicScenarioRequest interface.
 */
export function instanceOfInternalApiRerunPeriodicScenarioRequest(value: object): value is InternalApiRerunPeriodicScenarioRequest {
    if (!('scenarioHandle' in value) || value['scenarioHandle'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function InternalApiRerunPeriodicScenarioRequestFromJSON(json: any): InternalApiRerunPeriodicScenarioRequest {
    return InternalApiRerunPeriodicScenarioRequestFromJSONTyped(json, false);
}

export function InternalApiRerunPeriodicScenarioRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRerunPeriodicScenarioRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'scenarioHandle': json['scenarioHandle'],
        'timestamp': (new Date(json['timestamp'])),
    };
}

export function InternalApiRerunPeriodicScenarioRequestToJSON(json: any): InternalApiRerunPeriodicScenarioRequest {
    return InternalApiRerunPeriodicScenarioRequestToJSONTyped(json, false);
}

export function InternalApiRerunPeriodicScenarioRequestToJSONTyped(value?: InternalApiRerunPeriodicScenarioRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scenarioHandle': value['scenarioHandle'],
        'timestamp': value['timestamp'].toISOString(),
    };
}

